import React from 'react';
import { Section } from './ui/Section';
export function NotForYou() {
  return <Section className="text-center max-w-lg" data-id="element-71">
      <h2 className="text-2xl font-serif mb-8 text-warm-brown/80" data-id="element-72">
        Para quién NO es
      </h2>

      <ul className="space-y-4 text-left inline-block" data-id="element-73">
        <li className="flex items-start gap-3 text-warm-brown/70" data-id="element-74">
          <span className="text-terracotta font-bold text-xl leading-none" data-id="element-75">
            –
          </span>
          <span data-id="element-76">Si buscás magia instantánea</span>
        </li>
        <li className="flex items-start gap-3 text-warm-brown/70" data-id="element-77">
          <span className="text-terracotta font-bold text-xl leading-none" data-id="element-78">
            –
          </span>
          <span data-id="element-79">Si querés promesas sobrenaturales</span>
        </li>
        <li className="flex items-start gap-3 text-warm-brown/70" data-id="element-80">
          <span className="text-terracotta font-bold text-xl leading-none" data-id="element-81">
            –
          </span>
          <span data-id="element-82">
            Si necesitás tratamiento clínico urgente (esto acompaña, no
            reemplaza)
          </span>
        </li>
      </ul>
    </Section>;
}